<script>
import { createNamespacedHelpers } from 'vuex';

import auth from '@/auth';
import { ROUTE_LOGIN_PHONE, ROUTE_LOGIN_GUIDE } from '@/router/names';
import { WECHAT_GRANT } from '@/store/wechat/types';
import { WECHAT_BIND_COACH } from '@/store/coach/types';

const { mapActions } = createNamespacedHelpers('wechat');
const { mapActions: mapCoachActions } = createNamespacedHelpers('coach');

export default {
    async mounted() {
        const { code } = this.$route.query;

        // 微信登录
        await this.wechatGrant({
            code,
        });
        if (auth.loggedIn()) {
            // 已登录用户尝试绑定当前微信
            await this.wechatBind();
            // 已登录用户跳转
            this.$router.replace({
                name: ROUTE_LOGIN_GUIDE,
            });
            return;
        }
        // 未登录跳转到手机登录
        this.$router.replace({
            name: ROUTE_LOGIN_PHONE,
        });
    },
    methods: {
        ...mapActions({
            wechatGrant: WECHAT_GRANT,
        }),
        ...mapCoachActions({
            wechatBind: WECHAT_BIND_COACH,
        }),
    },
    render() {
        return null;
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/wechat/Callback.vue